import { formatDateTime } from "@/utils/helper";

export const columns = () => {
  return [
    {
      accessorKey: "created_at",
      header: "Timestamp",
      cell: ({ row }) => (
        <span>
          {formatDateTime(row.getValue("created_at"), false, false, true)} UTC
        </span>
      ),
    },
    {
      accessorKey: "causer.first_name",
      header: "Causer Name",
      cell: ({ row }) => <div>{row.original.causer?.first_name ?? "-"} </div>,
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorKey: "properties.ip",
      header: "User Public IP Address",
    },
    {
      accessorKey: "properties.user_agent",
      header: "User Browser Agent",
    },
  ];
};
